export function deriveTitle(sourceText: string): string {
  const firstLine = sourceText.trim().split("\n")[0]?.trim() ?? "";
  if (firstLine.length === 0) return "Untitled reading";
  return firstLine.length > 80 ? `${firstLine.slice(0, 77)}...` : firstLine;
}
